import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1, 0),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(1),
      },
    },
    infiniteScroll: {
      overflow: 'hidden',
    },
    companiesGroup: {
      marginBottom: theme.spacing(3),
    },
  })
);
